<template>
    <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Arrow">
            <path id="Path 6456" d="M1.17529 7.15448L7.17606 1.15372L13.1768 7.15448" stroke="#5F5F63" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconChevronUp"
}
</script>

<style scoped>

</style>
